/* import __COLOCATED_TEMPLATE__ from './manage-data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  isMessengerPage?: boolean;
  isSettingsPage?: boolean;
}

const StandaloneSalesforceManageData = templateOnlyComponent<Args>();
export default StandaloneSalesforceManageData;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::ManageData': typeof StandaloneSalesforceManageData;
    'standalone/salesforce/manage-data': typeof StandaloneSalesforceManageData;
  }
}
